// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcm_a bhc_b bhc_tu bhc_qz bhc_ra bhc_uo","PanelFooter--link":"bcm_b"};